__webpack_require__.p = "/reports-categorized-tooltip/onboarding/";